/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// IMAGE UPLOAD STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	imageupload: {
		// styles come from parent containers that house this 
	}
};